import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { memo } from 'react';
import TextField from '@material-ui/core/TextField';
import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from './styles';

var Input = function (props) {
  var classes = useStyles(props);

  var _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      hide = props.hide,
      _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size,
      error = props.error,
      label = props.label,
      InputLabelProps = props.InputLabelProps,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      endIcon = props.endIcon,
      startIcon = props.startIcon,
      inputProps = props.InputProps,
      rest = _objectWithoutPropertiesLoose(props, ["loading", "hide", "size", "error", "label", "InputLabelProps", "variant", "endIcon", "startIcon", "InputProps"]);

  if (hide) return null;
  return /*#__PURE__*/React.createElement(TextField, _extends({
    classes: classes,
    size: size,
    variant: variant,
    label: label,
    InputLabelProps: _extends({}, InputLabelProps),
    InputProps: _extends({}, inputProps, {
      startAdornment: startIcon || (inputProps == null ? void 0 : inputProps.startAdornment),
      endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
        color: "inherit",
        size: 20
      }) : endIcon || (inputProps == null ? void 0 : inputProps.endAdornment) || null)
    }),
    helperText: error,
    error: !!error
  }, rest));
};

export default /*#__PURE__*/memo(Input);